"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionType = void 0;
var ActionType;
(function (ActionType) {
    ActionType["SLIDER"] = "slider";
    ActionType["INPUT"] = "input";
    ActionType["SET_INPUT_INVALID"] = "setInputInvalid";
    ActionType["UPDATE_STATE"] = "updateState";
    ActionType["RESET"] = "reset";
})(ActionType || (exports.ActionType = ActionType = {}));
